import { IMAGES } from "@/data/content";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CtaBanner } from "@/components/CtaBanner";
import { Eyebrow, SectionTitle } from "@/components/Section";
import { ProfilesExplorer } from "@/components/ProfilesExplorer";
import { Blob } from "@/components/Decor";

const SIGNALS = [
  { t: "Οι πωλήσεις εξαρτώνται από λίγα άτομα ή από τυχαίες ευκαιρίες", tone: "#C26D52" },
  { t: "Οι αποφάσεις παίρνονται με διαίσθηση, όχι με δεδομένα", tone: "#2C4A6F" },
  { t: "Η καθημερινότητα καταναλώνεται σε χειροκίνητες, επαναλαμβανόμενες εργασίες", tone: "#5A7265" },
  { t: "Υπάρχει φιλοδοξία για εξαγωγές αλλά όχι οργανωμένο πλάνο", tone: "#6F86A3" },
  { t: "Τα εργαλεία — CRM, AI, reporting — υπάρχουν αλλά δεν αξιοποιούνται", tone: "#C5A059" },
];

export default function WhoWeServe() {
  return (
    <div data-testid="who-we-serve-page">
      <PageHero
        testId="who-hero"
        eyebrow="Σε Ποιους Απευθυνόμαστε"
        tone="#5A7265"
        image={IMAGES.warehouse}
        title={
          <>
            Επιχειρήσεις που θέλουν να λειτουργούν καλύτερα <span className="italic text-[#5A7265]">και να μεγαλώνουν.</span>
          </>
        }
        desc="Δουλεύουμε με επιχειρήσεις που θέλουν περισσότερες πωλήσεις, καλύτερη οργάνωση και πρακτική χρήση της τεχνολογίας — χωρίς περιττή πολυπλοκότητα. Επιλέξτε την κατηγορία που σας ταιριάζει."
      />

      <section className="relative py-16 lg:py-24 overflow-hidden">
        <Blob color="rgba(90,114,101,0.14)" className="top-0 right-[-10%]" size={600} />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <ProfilesExplorer />
          </Reveal>
        </div>
      </section>

      <section className="relative py-24 lg:py-32 mesh-sage overflow-hidden" data-testid="signals-section">
        <div className="absolute inset-x-0 top-0 hairline" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-5 lg:sticky lg:top-32">
            <Eyebrow tone="#5A7265">Πότε Είμαστε Χρήσιμοι</Eyebrow>
            <SectionTitle className="mt-6">Σημάδια ότι η επιχείρηση χρειάζεται <span className="italic text-[#5A7265]">τάξη και σύστημα.</span></SectionTitle>
            <p className="mt-6 text-base leading-relaxed text-[#3B4A5E]">
              Αν αναγνωρίζετε δύο ή περισσότερα από αυτά, υπάρχει σχεδόν πάντα περιθώριο για ουσιαστική βελτίωση — συχνά με λιγότερη προσπάθεια από όση φαντάζεστε.
            </p>
          </Reveal>
          <div className="lg:col-span-7 space-y-4">
            {SIGNALS.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.07}>
                <div data-testid={`signal-card-${i}`} className="group flex items-center gap-5 rounded-[24px] border border-[#0E1B31]/[0.07] bg-white/85 backdrop-blur p-6 surface-hover" style={{ marginLeft: `${(i % 3) * 16}px` }}>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl font-mono-brand text-sm text-white" style={{ background: s.tone }}>0{i + 1}</span>
                  <p className="text-[15px] leading-relaxed text-[#0E1B31]">{s.t}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner
        title="Αναγνωρίζετε την επιχείρησή σας;"
        subtitle="Η πρώτη συζήτηση δεν δεσμεύει — σας δίνει όμως μια ξεκάθαρη εικόνα για το πού βρίσκεστε και τι μπορεί να αλλάξει."
        buttonLabel="Ξεκινήστε τη συζήτηση"
      />
    </div>
  );
}
